<template>
	<div class="topbar">
		<div class="topbar__left">
			<el-button type="text" class="topbar__toggle" >
				<i class="ri-menu-fill" id="toggle-menu"></i>
			</el-button>
			<div class="topbar__search">
					<i class="ri-search-line"></i>
					<input type="text" class="topbar__search-input" placeholder="Search...">
			</div>
		</div>
		<div class="topbar__user">
			<span class="topbar__user-greeting">Hi,</span>
			<span class="topbar__user-username">eldynmhmmd</span>
		</div>
	</div>
</template>

<script>
import { useToggle } from '@/composables/useToggle.js'

export default {
	setup() {
		let { isFull, toggle } = useToggle()
		return {
			isFull,
			toggle
		}
	}
}
</script>

<style>

</style>